import { useCallback } from 'react'

export const LANDING_PAGE_LENDING = 'landing_page_lending'
function useKva() {
  const addEventPageView = useCallback(
    (pageView, fieldsObject = {}) => {
      try {
        if (typeof window.kva !== 'undefined') {
          const contentAction = {
            contentAction: JSON.stringify({
              ...fieldsObject,
            }),
          }
          window.kva(
            'create',
            "",
            'auto',
            'kiotfinance_tracker',
          )
          window.kva(
            'kiotfinance_tracker.send',
            'pageview',
            `${pageView}`,
            contentAction,
          )
        }
      } catch (err) {
        console.error('err kva page view', err)
      }
    },
    [],
  )

  const addEventAction = useCallback(
    (
      eventCategory,
      eventAction,
      eventLabel,
      fieldsObject = {},
      eventValue = 0,
    ) => {
      try {
        if (typeof kva !== 'undefined') {
          const contentAction = {
            contentAction: JSON.stringify({
              ...fieldsObject,
            }),
          }
          window.kva(
            'create',
            '',
            'auto',
            'kiotfinance_tracker',
          )
          window.kva(
            'kiotfinance_tracker.send',
            'event',
            `${eventCategory}`,
            eventAction,
            eventLabel,
            eventValue,
            contentAction,
          )
        }
      } catch (err) {
        //
      }
    },
    [],
  )

  return {
    addEventAction,
    addEventPageView,
  }
}

export default useKva
